export const visitBanner = {
  title: "Não fique com dúvidas!",
  description: "Agende sua visita no dia e hora que quiser e descubra como funcionamos.",
  button: "Agendar visita"
};
